@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.feed.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringArrayResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.feed.resources/"

@delegate:ResourceContentHash(557_587_339)
internal val Res.array.feed_months: StringArrayResource by lazy {
      StringArrayResource("string-array:feed_months", "feed_months", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 92, 208),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 92, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80, 84),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainArray0Resources(map: MutableMap<String, StringArrayResource>) {
  map.put("feed_months", Res.array.feed_months)
}
